const EventNames = {
    eventJoinPopup: {
        show: 'SHOW_JOIN_EVENT_POPUP',
        hide: 'HIDE_JOIN_EVENT_POPUP'
    }
}
 
export default EventNames;